import { useSnapshot } from "valtio";
import { WidthSimpleButton } from "./WidthSimpleButton";
import { selfAssemblyInputState } from "shared/store/selfAssembly/selfAssemblyInputs";

type OpdekdeurSelfMontageWidthsType = {
  setWidth: (width: number) => void;
  selectedWidth: number;
  minimumWidth: number;
};

export const opdekdeurSelectableWidths = [740, 790, 840, 890, 940, 990];

export const OpdekdeurSelfMontageWidths = ({
  setWidth,
  selectedWidth,
  minimumWidth,
}: OpdekdeurSelfMontageWidthsType) => {
  const widthInputFieldSnapshot = useSnapshot(selfAssemblyInputState);
  const availableWidths = opdekdeurSelectableWidths.filter(
    (width) => width >= minimumWidth,
  );

  return (
    <div
      data-testid="width-opdekdeur-buttons"
      className="gg-mt-0.5 gg-grid gg-grid-cols-3 gg-gap-x-5 gg-gap-y-4"
    >
      {availableWidths.map((width) => (
        <WidthSimpleButton
          key={width}
          onClick={() => setWidth(width)}
          isActive={
            selectedWidth === width && !!widthInputFieldSnapshot.widthInput
          }
        >
          {width}
        </WidthSimpleButton>
      ))}
    </div>
  );
};
